import { ReactNode, forwardRef } from 'react';
import styles from './PersonalCodeWrapper.module.css';
import { Typography, Stack } from '@mui/material';

interface PersonalCodeWrapperProps {
    isActive: boolean;
    children: ReactNode;
    onActivate: () => void;
    title?: string;
}

export const PersonalCodeWrapper = forwardRef<HTMLDivElement, PersonalCodeWrapperProps>(
    ({ isActive, children, onActivate, title }, ref) => {
        return (
            <div
                ref={ref}
                className={`${styles.personalCodeBox} ${isActive ? styles.active : styles.inactive}`}
                onClick={onActivate}
            >
                <Stack
                    spacing={2}
                    sx={{
                        alignItems: 'stretch',
                        width: '100%'
                    }}>
                    <Typography variant="body1" sx={{
                        fontWeight: '500'
                    }}>
                        {title}
                    </Typography>
                    {children}
                </Stack>
            </div>
        );
    }
);

PersonalCodeWrapper.displayName = 'PersonalCodeWrapper';